import api from "@/lib/api";

export const getViews = (object) => api.get("/list-views", { params: { object } });
export const createView = (body) => api.post("/list-views", body);
export const updateView = (id, body) => api.put(`/list-views/${id}`, body);
export const deleteView = (id) => api.delete(`/list-views/${id}`);
